module.exports = __webpack_public_path__ + "static/media/disputesMenuIcon.e89552af.svg";